export default __webpack_public_path__ + "static/media/Paulette Gabriella Presidente.cfd5e59e.jpg";